import React, { useEffect, useState } from "react";
import Login from "./Login";
import ChangePassword from "./ChangePassword";

interface loginUIProps {
  loginState: boolean;
  loginStateHandler: () => void;
}
const LoginUI: React.FC<loginUIProps> = ({
  loginState,
  loginStateHandler,
}: loginUIProps) => {
  const [loggedIn, setLoggedIn] = useState(false);
  useEffect(() => {
    if (loggedIn) {
      console.log("In use effect ", loggedIn);
      setLoggedIn(true);
    }
  }, [loggedIn]);

  // IMP and being used
  const loginHandler = () => {
    console.log("In login Handler ", loggedIn);
    setLoggedIn(true);
  };



  const [changePassword, setChangePassword] = useState(false);
  useEffect(() => {
    if (changePassword) {
      console.log("In change password Use effect ", changePassword);
      setChangePassword(true);
    }
  }, [changePassword]);

  const changePasswordHandler = () => {
    console.log("In Password Handler ", changePassword);
    setChangePassword(true);
  };


  const [changePassDone, setChangePassDone] = useState(false);
  useEffect(() => {
    if (changePassDone) {
      console.log("In change password Use effect ", changePassDone);
      setChangePassDone(true);
    }
  }, [changePassDone]);

  const changePassDoneHandler = () => {
    console.log("In Password Handler ", changePassDone);
    setChangePassDone(true);
  };
  return (
    <div className="viewer-container">
      {!loggedIn ? (
        <Login
          //loggedIn={loggedIn}
          loginHandler={loginHandler}
          //changePassword={changePassword}
          changePasswordHandler={changePasswordHandler}
          loginStateHandler={loginStateHandler}
        />
      ) : (
        <ChangePassword
          changePassword={changePassword}
          changePasswordHandler={changePasswordHandler}
          changePassDone={changePassDone}
          changePassDoneHandler={changePassDoneHandler}
          loginStateHandler={loginStateHandler}
        />
      )}
    </div>
  );
};

export default LoginUI;
